<template>
  <div class="footer" :class="{ hide: currentStep === 3 }">
    <div class="container">
      <AppFooterCategory
        v-for="category in categories"
        :key="category.id"
        :category="category"
        :selected-category-id="selectedCategoryId"
        @selectPopup="selectPopup"
        @closePopup="selectedCategoryId = null"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppFooterCategory from './AppFooterCategory';

export default {
  name: 'AppFooter',

  data() {
    return {
      selectedCategoryId: null,
    };
  },

  components: {
    AppFooterCategory,
  },

  computed: {
    ...mapState('step', ['currentStep']),
    ...mapState('category-products', ['categories']),
  },

  methods: {
    selectPopup(categoryId) {
      this.selectedCategoryId = categoryId;
    },
  },
};
</script>
